/**
 * Countries blocked from starting Rate Connect campaigns
 * Blocked due to tax/legal reasons
 *
 * Country IDs:
 * - 8: Egypt
 * - 195: Tanzania
 * - 143: Nigeria
 * - 96: Kenya
 * - 207: Uganda
 */

export const RC_BLOCKED_COUNTRIES: readonly number[] = [8, 195, 143, 96, 207]
